export const mainCls = 'user-input';

export default {
  [`${mainCls}`]: {
    position: 'relative',
  },
  [`${mainCls}__ctn`]: {
    position: 'relative',
    color:'#96a1b0',
  },
  [`${mainCls}--error`]: {
    borderColor: '#ff8000!important',
  },  
  [`${mainCls}__errorMsg`]: {
    display: 'flex',
    alignItems: 'flex-start',
    lineHeight:'20px',
    '& .iconFill':{
      marginTop:'2px',
      marginRight:'5px',
      minWidth: 14,
    }
  },
  [`${mainCls}__fieldDesc`]: {
    lineHeight:'20px',
  },   
}